/*
  Links to another host open in a new tab inside article bodies and product
  descriptions, Helix included, so a reader who follows one keeps the store
  open. Run in the browser rather than at transform time so it also covers
  content entered in the admin after cutover. Marketing pages are left as
  pages.py builds them.
*/
(function () {
  var scopes = '.abz-article__body, .abz-article__abstract, .abz-description';
  function mark(root) {
    root.querySelectorAll('a[href]').forEach(function (a) {
      if (!/^https?:/i.test(a.href) || a.host === location.host) return;
      a.target = '_blank';
      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      a.setAttribute('rel', rel.join(' '));
    });
  }
  function run() {
    document.querySelectorAll(scopes).forEach(mark);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
